module.exports = __webpack_public_path__ + "static/media/icon-refresh.e541bd44.svg";